<template>
  <footer class="footer">
    <div class="content columns">
      <div class="column has-text-centered-mobile">
        <p>
          <strong>The UpTogether Community</strong> by
          <a href="https://uptogether.org">UpTogether</a>.
        </p>
      </div>
      <div class="column is-one-third-desktop">
        <p class="footer-link bd-has-subtitle">
          <a href="https://www.uptogether.org/terms-of-use/">
            <span class="footer-link-icon has-text-star">
              <svg
                class="svg-inline--fa fa-star fa-w-18"
                aria-hidden="true"
                data-prefix="fas"
                data-icon="star"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                ></path>
              </svg>
            </span>
            <strong>
              {{ $t('footer__tos') }}
            </strong>
            <em>
              {{ $t('footer__tos_detail') }}
            </em>
          </a>
        </p>

        <p class="footer-link bd-has-subtitle">
          <a href="https://www.uptogether.org/privacy-policy/">
            <span class="footer-link-icon has-text-danger">
              <svg
                class="svg-inline--fa fa-heart fa-w-16"
                aria-hidden="true"
                data-prefix="fas"
                data-icon="heart"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                ></path>
              </svg>
            </span>
            <strong>
              {{ $t('footer__privacy') }}
            </strong>
            <em>
              {{ $t('footer__privacy_detail') }}
            </em>
          </a>
        </p>
        <p class="footer-link bd-has-subtitle">
          <a href="https://www.uptogether.org/code-of-conduct/">
            <span class="footer-link-icon has-text-patreon">
              <svg
                class="svg-inline--fa fa-patreon fa-w-16"
                aria-hidden="true"
                data-prefix="fab"
                data-icon="patreon"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                data-fa-i2svg=""
              >
                <path
                  fill="currentColor"
                  d="M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"
                ></path>
              </svg>
            </span>
            <strong>
              {{ $t('footer__coc') }}
            </strong>
            <em>
              {{ $t('footer__coc_detail') }}
            </em>
          </a>
        </p>
      </div>
    </div>
    <ExternalScripts />
  </footer>
</template>

<script>
import ExternalScripts from './ExternalScripts'

export default {
  name: 'Footer',
  components: {
    ExternalScripts,
  },
}
</script>
<style scoped>
.footer {
  background-color: #fafafa;
}

.footer-star:hover {
  box-shadow: 0 3rem 3rem -1.25rem rgba(10, 10, 10, 0.1);
  transform: translateY(-0.5rem);
}
.footer-star:hover .footer-subtitle,
.footer-star:hover .footer-title {
  color: #3273dc;
}
.footer-star.bd-is-expo,
.footer-star.bd-is-love {
  padding-bottom: 156px;
}
.footer-star.bd-is-expo .footer-title,
.footer-star.bd-is-love .footer-title {
  align-items: center;
  display: flex;
  justify-content: center;
}
.footer-star.bd-is-expo .footer-title .icon,
.footer-star.bd-is-love .footer-title .icon {
  margin-right: 0.25em;
}
.footer-star.bd-is-expo {
  background-image: url(/images/footer/expo-examples.png);
  background-repeat: repeat-x;
  background-position: bottom center;
  background-size: 352px 156px;
}
.footer-star.bd-is-love {
  background-image: url(/images/footer/love.png);
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: 440px 180px;
}
.footer-star-header {
  padding: 1.5rem;
}
.footer-star-figure {
  height: 156px;
  margin-top: -1rem;
}
.footer-links {
  margin-top: 6rem;
  padding-bottom: 6rem;
}
.footer-links a {
  color: currentColor;
}
.footer-links a:hover {
  color: #3273dc;
}
.footer-link-title {
  color: #363636;
  font-size: 1.25rem;
  font-weight: 600;
}
.footer-link-title:not(:first-child) {
  margin-top: 1.5em;
}
.footer-link {
  margin-top: 0.5rem;
}
.footer-link.bd-is-more {
  font-size: 0.875rem;
}
.footer-link.bd-is-more a:not(:hover) {
  color: #b5b5b5;
}
.footer-link.bd-has-subtitle a {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.footer-link.bd-has-subtitle a strong {
  flex-grow: 1;
  flex-shrink: 1;
  font-weight: unset;
}
.footer-link.bd-has-subtitle a em {
  display: block;
  font-size: 0.875rem;
  font-style: normal;
}
.footer-link.bd-has-subtitle a:not(:hover) em {
  color: #b5b5b5;
}
@media screen and (max-width: 768px) {
  .footer-link.bd-has-subtitle a {
    flex-wrap: wrap;
    margin-top: 1rem;
  }
  .footer-link.bd-has-subtitle a em {
    width: 100%;
  }
}
@media screen and (min-width: 769px), print {
  .footer-link.bd-has-subtitle a em {
    margin-left: 1rem;
    text-align: right;
  }
}
.footer-link-icon {
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 0.5em;
  text-align: center;
  width: 1em;
}
footer {
  border-top: 1px solid #afafaf !important;
}
</style>
